import React from "react";

/**
 * @param {{ width?: number, height?: number, color?: string, style?: React.CSSProperties }} props
 */
export default function PlusIcon({
  width = 20,
  height = 20,
  color = "#111",
  style = {},
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="10"
        y1="4"
        x2="10"
        y2="16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="4"
        y1="10"
        x2="16"
        y2="10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
